var _rect, _path, _rect2, _path2, _rect3, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborationSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.71143,
    y: 25.2133,
    width: 3,
    height: 4.53344,
    rx: 1.5,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 33.5521C6 33.1151 6.24129 32.7706 6.57246 32.638C7.631 32.2139 9.08066 31.7458 10.2114 31.7458C11.3422 31.7458 12.7918 32.2139 13.8504 32.638C14.1815 32.7706 14.4228 33.1151 14.4228 33.5521V37.2125H6V33.5521Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 25.2133,
    width: 3,
    height: 4.53344,
    rx: 1.5,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7886 33.5521C17.7886 33.1151 18.0299 32.7706 18.361 32.638C19.4196 32.2139 20.8692 31.7458 22 31.7458C23.1307 31.7458 24.5804 32.2139 25.6389 32.638C25.9701 32.7706 26.2114 33.1151 26.2114 33.5521V37.2125H17.7886V33.5521Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2886,
    y: 25.2133,
    width: 3,
    height: 4.53344,
    rx: 1.5,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5771 33.5521C29.5771 33.1151 29.8184 32.7706 30.1496 32.638C31.2082 32.2139 32.6578 31.7458 33.7886 31.7458C34.9193 31.7458 36.369 32.2139 37.4275 32.638C37.7587 32.7706 38 33.1151 38 33.5521V37.2125H29.5771V33.5521Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2796 13.3066C27.3084 13.0826 27.33 12.8586 27.33 12.6206C27.33 12.3826 27.3084 12.1586 27.2796 11.9346L28.7981 10.7796C28.9348 10.6746 28.9708 10.4856 28.8844 10.3316L27.4452 7.90963C27.3588 7.75563 27.1645 7.69963 27.0062 7.75563L25.2143 8.45563C24.8401 8.17563 24.4371 7.94463 23.9981 7.76963L23.7246 5.91464C23.7127 5.83228 23.6703 5.75697 23.6054 5.70284C23.5405 5.64872 23.4575 5.61949 23.372 5.62064L20.4935 5.62064C20.3136 5.62064 20.1624 5.74664 20.1408 5.91464L19.8674 7.76963C19.4284 7.94463 19.0254 8.18263 18.6512 8.45563L16.8593 7.75563C16.6938 7.69263 16.5067 7.75563 16.4203 7.90963L14.981 10.3316C14.8875 10.4856 14.9307 10.6746 15.0674 10.7796L16.5858 11.9346C16.5571 12.1586 16.5355 12.3896 16.5355 12.6206C16.5355 12.8516 16.5571 13.0826 16.5858 13.3066L15.0674 14.4616C14.9307 14.5666 14.8947 14.7556 14.981 14.9096L16.4203 17.3316C16.5067 17.4856 16.701 17.5416 16.8593 17.4856L18.6512 16.7856C19.0254 17.0656 19.4284 17.2966 19.8674 17.4716L20.1408 19.3266C20.1624 19.4946 20.3136 19.6206 20.4935 19.6206H23.372C23.5519 19.6206 23.703 19.4946 23.7246 19.3266L23.9981 17.4716C24.4371 17.2966 24.8401 17.0586 25.2143 16.7856L27.0062 17.4856C27.1717 17.5486 27.3588 17.4856 27.4452 17.3316L28.8844 14.9096C28.9708 14.7556 28.9348 14.5666 28.7981 14.4616L27.2796 13.3066ZM21.9327 15.0706C20.5438 15.0706 19.414 13.9716 19.414 12.6206C19.414 11.2696 20.5438 10.1706 21.9327 10.1706C23.3216 10.1706 24.4515 11.2696 24.4515 12.6206C24.4515 13.9716 23.3216 15.0706 21.9327 15.0706Z",
    fill: "#C63031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationSupport);
export default __webpack_public_path__ + "static/media/Collaboration & Support.bd3b483555337e7a9bf1c9647397032f.svg";
export { ForwardRef as ReactComponent };